






















/* General */
import Vue from 'vue'

/* Mixins */

/* Components */

/* Helpers */

/* Data types */
import { IMenuItemsOptionsItem } from '@/types/data-objects/items'
import { SortOptionValues } from '@/types'

/* API */

export default Vue.extend({
  name: 'IfpFilterSort',

  props: {
    selectedSort: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      sortOptions: [
        {
          label: 'Updated',
          value: SortOptionValues.UPDATED_RECENT,
        },
        {
          label: 'Updated Last',
          value: SortOptionValues.UPDATED_OLDEST,
        },
        {
          label: 'Created',
          value: SortOptionValues.CREATED_RECENT,
        },
        {
          label: 'Created Last',
          value: SortOptionValues.CREATED_OLDEST,
        },
        {
          label: 'Due Date',
          value: SortOptionValues.DUE_DATE,
        },
        {
          label: 'Title',
          value: SortOptionValues.TITLE,
        },
        {
          label: 'Status',
          value: SortOptionValues.STATUS,
        },
        {
          label: 'Assignee',
          value: SortOptionValues.ASSIGNEE,
        },
        {
          label: 'Priority',
          value: SortOptionValues.PRIORITY,
        },
      ] as IMenuItemsOptionsItem[],
    }
  },

  computed: {
    selectedSortLabel(): string {
      const selectedSort = this.sortOptions.find(
        sort => sort.value === this.selectedSort,
      )
      return selectedSort ? selectedSort.label : 'Select sort'
    },
  },

  methods: {
    handleSelectedSort(value: string) {
      this.$emit('sort-updated', value)
      // @ts-ignore
      this.$refs.dropdownRef.handleClose()
    },
  },
})
